import httpClientService from '@/services/httpClientService';

export default {
	login: (userCredentials) =>
		httpClientService.Post('/IdentityModule/api/Auth', userCredentials),
	refreshToken: (accessToken) =>
		httpClientService.Post(
			'/IdentityModule/api/Auth/RefreshToekn',
			accessToken
		),

	getWindowsUsername: () =>
		httpClientService.Get(
			'/IdentityWindowsModule/api/Auth/windowsUsername'
		),
	loginWindows: () =>
		httpClientService.Get('/IdentityWindowsModule/api/Auth'),
};
